// The brand mark (orange roofline over white walls on a near-black tile) plus
// the wordmark. Inline SVG so it scales crisp everywhere; public/logo.svg is
// the same mark for use outside the app.
export function Mark({ className = 'h-9 w-9' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#0b1220" />
      <path
        d="M13 33 32 16l19 17"
        fill="none"
        stroke="#f26b1d"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 48V34h22v14"
        fill="none"
        stroke="#ffffff"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Wordmark({ tone = 'ink' }) {
  const base = tone === 'white' ? 'text-white' : 'text-ink'
  return (
    <span className={`text-[17px] font-extrabold tracking-[-0.02em] whitespace-nowrap ${base}`}>
      Boss <span className="text-primary">Contractor</span> Agency
    </span>
  )
}
